import { useEffect } from "react";
import { useOnboardingStore } from "../../stores/onboardingStore";
import { OnboardingChat } from "./OnboardingChat";
import { OnboardingProgress } from "./OnboardingProgress";

export function OnboardingOverlay() {
  const { isRequired, messages, startConversation } = useOnboardingStore();

  useEffect(() => {
    if (isRequired && messages.length === 0) {
      startConversation();
    }
  }, [isRequired, messages.length, startConversation]);

  if (!isRequired) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-white flex flex-col">
      {/* Header */}
      <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
        <h1 className="text-lg font-semibold text-gray-900">
          Welcome to RunLens
        </h1>
        <OnboardingProgress />
      </div>

      {/* Chat area */}
      <div className="flex-1 overflow-hidden flex justify-center px-4">
        <div className="w-full max-w-xl flex flex-col">
          <OnboardingChat />
        </div>
      </div>
    </div>
  );
}
